/**
 * Mirrors @orpc/standard-server-fetch `toStandardBody` content-type handling.
 * Missing content-type is treated as JSON by the oRPC client.
 */
export function isOrpcCompatibleResponseContentType(
	contentType: string | null | undefined,
): boolean {
	if (!contentType) {
		return true;
	}
	const normalized = contentType.toLowerCase();
	return (
		normalized.startsWith("application/json") ||
		normalized.startsWith("multipart/form-data") ||
		normalized.startsWith("application/x-www-form-urlencoded") ||
		normalized.startsWith("text/event-stream")
	);
}

/** Content-types that indicate Next/HTML error pages rather than oRPC payloads. */
export function isLikelyNonOrpcHtmlResponseContentType(
	contentType: string | null | undefined,
): boolean {
	if (!contentType) {
		return false;
	}
	const normalized = contentType.toLowerCase();
	return (
		normalized.startsWith("text/html") ||
		normalized.startsWith("application/xhtml+xml")
	);
}
